import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useI18n } from "@/i18n";

const CONSENT_KEY = "xyrqelo_cookie_consent_v1";

function updateConsent(granted) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;
  const state = granted
    ? {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        personalization_storage: "granted",
        security_storage: "granted",
      }
    : {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "granted",
        personalization_storage: "granted",
        security_storage: "granted",
      };
  window.gtag("consent", "update", state);
}

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (!stored) {
        setVisible(true);
      } else {
        const parsed = JSON.parse(stored);
        updateConsent(parsed.granted === true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  // detect current language from path prefix, default ar
  const langPrefix = /^\/(en)(\/|$)/.test(location.pathname) ? "/en" : "/ar";

  const handle = (granted) => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ granted, ts: Date.now() }));
    } catch {}
    updateConsent(granted);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label={t("cookie_banner.aria_label")}
      className="fixed inset-x-3 bottom-3 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-50 rounded-md bg-white border border-[#d9d3c7] shadow-xl p-5"
      data-testid="cookie-banner"
    >
      <h3 className="font-serif text-lg text-[#0F2447] mb-2">{t("cookie_banner.title")}</h3>
      <p className="text-sm text-[#3d4757] leading-relaxed">{t("cookie_banner.body")}</p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <button
          type="button"
          onClick={() => handle(true)}
          className="flex-1 bg-[#0F2447] text-white px-4 py-2.5 text-sm rounded hover:bg-[#173257]"
          data-testid="cookie-accept"
        >
          {t("cookie_banner.accept")}
        </button>
        <button
          type="button"
          onClick={() => handle(false)}
          className="flex-1 border border-[#0F2447] text-[#0F2447] px-4 py-2.5 text-sm rounded hover:bg-[#f0eee8]"
          data-testid="cookie-reject"
        >
          {t("cookie_banner.reject")}
        </button>
      </div>
      <div className="mt-3 text-xs">
        <Link to={`${langPrefix}/cookies`} className="text-[#B85D3D] underline" data-testid="cookie-banner-policy">
          {t("cookie_banner.settings")}
        </Link>
      </div>
    </div>
  );
}
